/* eslint-disable radix */
const homepageBody = document.querySelector('.home.section-homepage');
const heroText = document.querySelector('.js-hero-text');
const heroContent = document.querySelector('.js-hero-content');
const homepageStats = document.querySelector('.js-homepage-stats');
const homepageImageGrid = document.querySelector('.js-homepage-image-grid');
const homepageAccordion = document.querySelector('.js-homepage-accordion');
const homepageCardSlider = document.querySelector('.js-homepage-card-slider');

// Only proceed if we're on the homepage (check for required elements)
const isHomepage = homepageBody;

if (isHomepage) {
  const homepageAccordionsArray = homepageAccordion.querySelectorAll('[data-accordion]');
  const homepageCardSliderPadding = homepageCardSlider?.querySelector('.layer');

  let heroTextHeight = '';
  let heroBottomPadding = '';
  let homepageStatsHeight = '';
  let homepageImageGridTopPadding = '';
  let homepageImageGridBottomPadding = '';
  let homepageAccordionHeight = '';
  let homepageCardSliderTopPadding = '';

  const setAccordionLineHeight = () => {
    // Homepage accordion line height calculation
    // Set height of image grid bottom padding, accordion height and card slider top padding
    homepageImageGridBottomPadding = parseInt(
      window.getComputedStyle(homepageImageGrid).paddingBottom
    );
    homepageAccordionHeight = homepageAccordion.offsetHeight;
    homepageCardSliderTopPadding = parseInt(
      window.getComputedStyle(homepageCardSliderPadding).paddingTop
    );

    const accordionLineHeight =
      homepageImageGridBottomPadding +
      homepageAccordionHeight +
      homepageCardSliderTopPadding;

    // set accordion line height
    homepageAccordion.style.setProperty(
      '--accordion-line-height',
      `${accordionLineHeight}px`
    );

    // set accordion top offest
    homepageAccordion.style.setProperty(
      '--accordion-top',
      `${homepageImageGridBottomPadding}px`
    );
  };

  const setHeroLineHeight = () => {
    // Hero line height calculation
    heroTextHeight = heroText.offsetHeight;
    heroBottomPadding = parseInt(window.getComputedStyle(heroContent).paddingBottom);
    homepageStatsHeight = homepageStats.offsetHeight;
    homepageImageGridTopPadding = parseInt(
      window.getComputedStyle(homepageImageGrid).paddingTop
    );

    const heroLineHeight =
      heroTextHeight +
      heroBottomPadding +
      homepageStatsHeight +
      homepageImageGridTopPadding;

    heroText.style.setProperty('--hero-line-height', `${heroLineHeight}px`);
    heroText.style.setProperty('--motion-scaleY', 1);
  };

  const setAccordionLineTransition = () => {
    // Set homepage accordion styles when scroll depth reaches top of accordion, only once
    const scrollDepth = window.scrollY;
    const accordionTop = homepageAccordion.getBoundingClientRect().top;

    if (scrollDepth >= accordionTop) {
      setTimeout(
        () => {
          homepageAccordion.style.setProperty('--accordion-motion-scaleY', 1);
          document.removeEventListener('scroll', setAccordionLineTransition);
        },
        { once: true }
      );
    }
  };

  // Set homepage Image Grid fly-up styles when scrolled past
  const setImageGridFlyUp = () => {
    const scrollDepth = window.scrollY;
    const homepageImageGridTop = homepageImageGrid.getBoundingClientRect().top;
    const gridImagesArray = homepageImageGrid.querySelectorAll(
      '.js-homepage-image-grid-image'
    );
    const gridContent = homepageImageGrid.querySelector('.js-homepage-image-grid-content');

    if (scrollDepth >= homepageImageGridTop) {
      gridImagesArray.forEach(image => {
        image.classList.add('-flyUp');
      });
      gridContent.classList.add('-flyUp');
      document.removeEventListener('scroll', setImageGridFlyUp);
    }
  };

  document.addEventListener('DOMContentLoaded', () => {
    setHeroLineHeight();
    setTimeout(() => {
      setAccordionLineHeight();
    }, 0);
    homepageAccordionsArray?.forEach(accordion => {
      accordion.addEventListener('transitionend', () => {
        setAccordionLineHeight();
      });
    });
  });

  document.addEventListener('scroll', setImageGridFlyUp);
  document.addEventListener('scroll', setAccordionLineTransition);
  window.addEventListener('resize', () => {
    setTimeout(() => {
      setAccordionLineHeight();
    }, 100);
  });
}
